import React from 'react';

const TaskIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.16669 16.25H17.5" stroke="#42389D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.16669 10.4167H17.5H9.16669Z" fill="#42389D" />
    <path d="M9.16669 10.4167H17.5" stroke="#42389D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.16669 4.58331H17.5" stroke="#42389D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M2.5 4.58335L3.33333 5.41669L5.83333 2.91669"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 10.4167L3.33333 11.25L5.83333 8.75"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 16.25L3.33333 17.0833L5.83333 14.5833"
      stroke="#42389D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TaskIcon;
